import React from "react"
import styles from "./Footer.module.css"
import logo from "../../images/logo.png"
import AnchorLink from "react-anchor-link-smooth-scroll"
import { MdPhone } from "react-icons/md"
import { MdEmail } from "react-icons/md"
import { FaFacebook } from "react-icons/fa"
import { FaInstagram } from "react-icons/fa"

const Footer = () => {
  return (
    <footer className={styles.container}>
      <div className={styles.content}>
        <div className={styles.aboutUs}>
          <img className={styles.logo} src={logo} alt="logo" />
          <p>
            Our vision is to deliver residential renovation and woodworking services at such a consistently high level of quality,professionalism, ethics,
            reliability, and integrity that we will set the standard for excellence in the renovation industry.
          </p>
        </div>
        <ul className={styles.navigation}>
          <li className={styles.navItem}>
            <AnchorLink href="#home-page" offset="0" className="linkTo">
              Home
            </AnchorLink>
          </li>
          <li className={styles.navItem}>
            <AnchorLink href="#about-page" offset="80" className="linkTo">
              About
            </AnchorLink>
          </li>
          <li className={styles.navItem}>
            <AnchorLink href="#gallery-page" offset="80" className="linkTo">
              Gallery
            </AnchorLink>
          </li>
          <li className={styles.navItem}>
            <AnchorLink href="#services-page" offset="80" className="linkTo">
              Services
            </AnchorLink>
          </li>
          <li className={styles.navItem}>
            <AnchorLink href="#testimonials-page" offset="80" className="linkTo">
              Testimonials
            </AnchorLink>
          </li>
          <li className={styles.navItem}>
            <AnchorLink href="#contact-page" offset="80" className="linkTo">
              Contact
            </AnchorLink>
          </li>
        </ul>
        <div className={styles.contactInfo}>
          <h2 className="light">Kenny:</h2>
          <div className={styles.phone}>
            <MdPhone fontSize="30px" />
            <a href="tel:+1613-725-7247">613-725-7247</a>
          </div>
          <h2 className="light">Maurice:</h2>
          <div className={styles.phone}>
            <MdPhone fontSize="30px" />
            <a href="tel:+1613-725-7247">613-725-7247</a>
          </div>
          <div className={styles.email}>
            <MdEmail fontSize="30px" />
            <a href="mailto:rightchoicerenos@gmail.com">rightchoicerenos@gmail.com</a>
          </div>
        </div>
        <div className={styles.socialMedia}>
          <a href="https://www.facebook.com/pages/category/Local-Business/Right-Choice-Renovations-205996086771225/" alt="facebook">
            <FaFacebook fontSize="50px" color="#4267b2" aria-label="Facebook" />
          </a>
          <a href="https://www.instagram.com/rightchoicereno_mk/" aria-label="Instagram">
            <FaInstagram fontSize="50px" color="#ffffff" alt="instgram" />
          </a>
        </div>
      </div>
      <div className={styles.copyrightContainer}>
        <div className={styles.copyright}>
          Right Choice Renovations &copy; {new Date().getFullYear()} | All Rights Reserved | Website by{" "}
          <a href="https://www.brandonvervoort.com">Brandon Vervoort</a>
        </div>
      </div>
    </footer>
  )
}

export default Footer
